<template>
  <div>
    <div class="weui-mask_transparent"></div>
    <div class="weui-toast">
      <i class="weui-loading weui-icon_toast"></i>
      <p class="weui-toast__content">{{ loadingText }}</p>
    </div>
  </div>
</template>
<style>
</style>
<script>
  export default{
    name: 'c-loading',
    data () {
      return {}
    },
    props: {
      loadingText: {
        type: String,
        default: '数据加载中'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?3091377f